import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const statusSelectStyles: StyleRulesCallback = () => ({
  root: {
    justifyContent: 'left',
  },
});

export default statusSelectStyles;
